<div class="modal-container-content centered">
  <app-icon icon="triangle-exclamation" type="solid" class="icon hide-mobile"></app-icon>
  <img class="show-mobile" src="/mobile-error.png" alt="error">
  <div class="text-heading">{{ errorInfo.title }}</div>
  <div class="text-subtitle">{{ errorInfo.description }}</div>
</div>
<div class="modal-container-footer">
  <app-button type="primary" (keydown.enter)="modalRef.close()" (click)="this.modalRef.close()">
    Sluiten
  </app-button>
</div>
